module.exports = __webpack_public_path__ + "img/icon-empty-content@3x.8304e7e9.png";